/* This file is automatically generated for @graphcommerce/ecommerce-ui */

export * from '.'
import { Plugin as GrecaptchaApolloErrorAlert } from '@graphcommerce/googlerecaptcha/plugins/GrecaptchaApolloErrorAlert'
import { Plugin as GrecaptchaApolloErrorFullPage } from '@graphcommerce/googlerecaptcha/plugins/GrecaptchaApolloErrorFullPage'
import { Plugin as GrecaptchaApolloErrorSnackbar } from '@graphcommerce/googlerecaptcha/plugins/GrecaptchaApolloErrorSnackbar'
import { ComponentProps } from 'react'
import { 
  ApolloErrorAlert as ApolloErrorAlertBase,
  ApolloErrorFullPage as ApolloErrorFullPageBase,
  ApolloErrorSnackbar as ApolloErrorSnackbarBase,
} from '.'

/**
 * Interceptor for `<ApolloErrorAlert/>` with these plugins:
 * 
 * - `@graphcommerce/googlerecaptcha/plugins/GrecaptchaApolloErrorAlert`
 */
type ApolloErrorAlertProps = ComponentProps<typeof ApolloErrorAlertBase>

function GrecaptchaApolloErrorAlertInterceptor(props: ApolloErrorAlertProps) {
  return <GrecaptchaApolloErrorAlert {...props} Prev={ApolloErrorAlertBase} />
}
export const ApolloErrorAlert = GrecaptchaApolloErrorAlertInterceptor

/**
 * Interceptor for `<ApolloErrorFullPage/>` with these plugins:
 * 
 * - `@graphcommerce/googlerecaptcha/plugins/GrecaptchaApolloErrorFullPage`
 */
type ApolloErrorFullPageProps = ComponentProps<typeof ApolloErrorFullPageBase>

function GrecaptchaApolloErrorFullPageInterceptor(props: ApolloErrorFullPageProps) {
  return <GrecaptchaApolloErrorFullPage {...props} Prev={ApolloErrorFullPageBase} />
}
export const ApolloErrorFullPage = GrecaptchaApolloErrorFullPageInterceptor

/**
 * Interceptor for `<ApolloErrorSnackbar/>` with these plugins:
 * 
 * - `@graphcommerce/googlerecaptcha/plugins/GrecaptchaApolloErrorSnackbar`
 */
type ApolloErrorSnackbarProps = ComponentProps<typeof ApolloErrorSnackbarBase>

function GrecaptchaApolloErrorSnackbarInterceptor(props: ApolloErrorSnackbarProps) {
  return <GrecaptchaApolloErrorSnackbar {...props} Prev={ApolloErrorSnackbarBase} />
}
export const ApolloErrorSnackbar = GrecaptchaApolloErrorSnackbarInterceptor
